export default "__VITE_ASSET__C9_GXhzX__"